import React, { Fragment, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { BsCurrencyExchange } from "react-icons/bs";

import { countries, capitalizeWords } from '../Utils/general'

import { MdOutlineDriveFileRenameOutline, MdOutlineBusinessCenter, MdAddAPhoto } from "react-icons/md"
import { FaFemale, FaMale } from 'react-icons/fa'
import { CiMail } from 'react-icons/ci'
import { AiOutlinePhone } from 'react-icons/ai'
import { TfiLocationPin } from 'react-icons/tfi'
import { HiOutlineReceiptTax } from 'react-icons/hi'
import { BiIdCard } from 'react-icons/bi'
import { GrOrganization, GrStatusGood } from 'react-icons/gr'
import { GiFamilyTree, GiDoorRingHandle, GiOrganigram, GiCancel } from 'react-icons/gi'

import '../Styles/Register.css'
import '../Styles/Form.css'

import man from '../Contents/images/utils/man.png'
import card from '../Contents/images/utils/card.png'

import Footer from '../Components/Footer'
import { useStateValue } from '../Utils/StateProvider'

function Register(props) {
    const { tool } = useParams()
    const [{ url }, payload] = useStateValue()
    const [regData, setRegData] = useState({ account_type: tool, gender: 'm', marital_status: 'single', employment_status: 'unemployed' })
    const [error, setError] = useState({
        status: false
    })
    const [showBackBtn, setShowBackBtn] = useState(false)
    const [activeStage, setActiveStage] = useState(1)
    const [responsePercentage, setResponsePercentage] = useState(0)
    const [registered, setRegistered] = useState(false)

    const form_row_count = 5
    const required_data_count = 12

    const loadImage = ele => document.getElementById(ele).click()

    const next = async () => {
        setError({ status: false })
        switch (activeStage) {
            case 1:
                if (
                    !regData.fname ||
                    !regData.lname ||
                    !regData.marital_status ||
                    !regData.email ||
                    !regData.phone ||
                    !regData.gender ||
                    !regData.zip ||
                    !regData.street ||
                    !regData.city ||
                    !regData.state ||
                    !regData.country ||
                    !regData.dob
                ) return setError({
                    status: true,
                    message: 'missing require param(s).'
                })

                setActiveStage(2)
                break;
            case 2:
                if (
                    !regData.profile_photo ||
                    !regData.state_of_origin ||
                    !regData.nationality ||
                    !regData.id_type ||
                    !regData.id_exp ||
                    !regData.id_front ||
                    !regData.id_number
                ) return setError({
                    status: true,
                    message: 'missing required param(s).'
                })

                setActiveStage(3)
                break;
            case 3:
                if (regData.employment_status !== 'unemployed') {
                    if (
                        !regData.employer ||
                        !regData.employer_address
                    ) return setError({
                        status: true,
                        message: 'missing required param(s)'
                    })
                }

                setActiveStage(4)
                break;
            case 4:
                if (
                    !regData.next_of_kin ||
                    !regData.next_of_kin_email ||
                    !regData.next_of_kin_phone ||
                    !regData.next_of_kin_address ||
                    !regData.next_of_kin_relation
                ) return setError({
                    status: true,
                    message: 'missing required param(s)'
                })

                setActiveStage(5)
                break;
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const formData = new FormData();

        Object.keys(regData).forEach(name => {
            formData.append(name, regData[name])
        })
        payload({ type: 'TOGGLE_PROCESSING', state: true })
        try {
            const response = await axios.post(`${url}/api/u`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: progressEvent => {
                    setResponsePercentage(
                        parseInt(
                            Math.round((progressEvent.loaded * 100) / progressEvent.total)
                        )
                    );
                }
            })
            setRegistered(true)
            setActiveStage(6)
        } catch (err) {
            console.error(err)
        } finally {
            payload({ type: 'TOGGLE_PROCESSING', state: false })
        }
    }

    useEffect(() => {
        setRegData({ ...regData, id_front: null, id_back: null, id_number: null, id_exp: null })
    }, [regData.id_type])
    useEffect(() => {
        setRegData({...regData, account_type: tool})
    }, [tool])
    useEffect(() => {
        payload({ type: 'PROCESSING', percent: responsePercentage })
    }, [responsePercentage])
    return (
        <Fragment>
            <main className='register'>
                <div className="container">
                    <div className="row top-banner">
                        <div className="desc">
                            <h1>{tool.replaceAll('-', ' ').toUpperCase()}</h1>
                        </div>
                    </div>
                    <div className="row form-container">
                        <form onSubmit={handleSubmit} className='default'>
                            {
                                error.status && (
                                    <div className="error-box">{error.message}</div>
                                )
                            }
                            {
                                activeStage === 1 && (
                                    <div className="form-pt-one personal-data">
                                        <h1>Personal Data</h1>
                                        <div className="form-row split-row">
                                            <div className="input-row">
                                                <input type="text" name='fname' id='fname' value={regData.fname || ''} onChange={e => setRegData({ ...regData, fname: e.target.value })} required />
                                                <label htmlFor="fname">First Name <span style={{ color: 'red' }}>*</span></label>
                                                <MdOutlineDriveFileRenameOutline />
                                            </div>
                                            <div className="input-row">
                                                <input type="text" name='lname' id='lname' value={regData.lname || ''} onChange={e => setRegData({ ...regData, lname: e.target.value })} required />
                                                <label htmlFor="lname">Last Name <span style={{ color: 'red' }}>*</span></label>
                                                <MdOutlineDriveFileRenameOutline />
                                            </div>
                                        </div>
                                        <div className="form-row split-row">
                                            <div className="input-row">
                                                <input type="text" name='mname' id='mname' value={regData.mname || ''} onChange={e => setRegData({ ...regData, mname: e.target.value })} />
                                                <label htmlFor="mname">Middle Name</label>
                                                <MdOutlineDriveFileRenameOutline />
                                            </div>
                                            <div className="input-row select-input">
                                                <select name="marital_status" id="marital_status" value={regData.marital_status || ''} onChange={e => setRegData({ ...regData, marital_status: e.target.value })} required>
                                                    <option value="single">Single</option>
                                                    <option value="married">Married</option>
                                                    <option value="divorced">Divorced</option>
                                                    <option value="widowed">Widowed</option>
                                                </select>
                                                <label htmlFor="marital_status">Marital Status <span style={{ color: 'red' }}>*</span></label>
                                                <GiDoorRingHandle />
                                            </div>
                                        </div>
                                        <div className="form-row input-row">
                                            <div className="input-row select-input">
                                                <select 
                                                    name="marital_status" 
                                                    id="marital_status" 
                                                    value={regData.currency || ''} 
                                                    onChange={e => setRegData({ ...regData, currency: e.target.value })} 
                                                    required
                                                >
                                                    <option value="{'currency': 'USD', 'name': 'US Dollar', 'symbol': '$'}">($) United States Dollar</option>
                                                    <option value="{'currency': 'GBP', 'name': 'Pound Sterling', 'symbol': '£'}" selected>(£) Pound Sterling</option>
                                                    <option value="{'currency': 'EUR', 'name': 'Euro', 'symbol': '€'}">(€) Euro</option>
                                                    <option value="{'currency': 'JPY', 'name': 'Japanese yen', 'symbol': '¥'}">(¥) Japanese Yen</option>
                                                </select>
                                                <label htmlFor="marital_status">Currency Type <span style={{ color: 'red' }}>*</span></label>
                                                <BsCurrencyExchange />
                                            </div>
                                        </div>
                                        <div className="form-row input-row">
                                            <input type="text" name='email' id='email' value={regData.email || ''} onChange={e => setRegData({ ...regData, email: e.target.value })} required />
                                            <label htmlFor="email">Email <span style={{ color: 'red' }}>*</span></label>
                                            <CiMail />
                                        </div>
                                        <div className="form-row input-row">
                                            <input type="text" name='phone' id='phone' value={regData.phone || ''} onChange={e => setRegData({ ...regData, phone: e.target.value })} required />
                                            <label htmlFor="phone">Phone <span style={{ color: 'red' }}>*</span></label>
                                            <AiOutlinePhone />
                                        </div>
                                        <div className="form-row split-row">
                                            <div className="input-row">
                                                <div className="form-row split-row">
                                                    <div className="column radio">
                                                        <label htmlFor="male">
                                                            <FaMale />
                                                            <span>Male<span style={{ color: 'red' }}>*</span></span>
                                                        </label>
                                                        <input type="radio" name='gender' value='m' id='male' defaultChecked onChange={e => setRegData({ ...regData, gender: e.target.value })} />
                                                    </div>
                                                    <div className="column radio">
                                                        <label htmlFor="female">
                                                            <FaFemale />
                                                            <span>Female<span style={{ color: 'red' }}>*</span></span>
                                                        </label>
                                                        <input type="radio" name='gender' value='f' id='female' onChange={e => setRegData({ ...regData, gender: e.target.value })} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="input-row">
                                                <input type="text" name='zip' id='zip' value={regData.zip || ''} onChange={e => setRegData({ ...regData, zip: e.target.value })} required />
                                                <label htmlFor="zip">ZIP <span style={{ color: 'red' }}>*</span></label>
                                                <TfiLocationPin />
                                            </div>
                                        </div>
                                        <div className="form-row input-row">
                                            <input type="text" name='street' id='street' value={regData.street || ''} onChange={e => setRegData({ ...regData, street: e.target.value })} required />
                                            <label htmlFor="street">Street <span style={{ color: 'red' }}>*</span></label>
                                            <TfiLocationPin />
                                        </div>
                                        <div className="form-row split-row">
                                            <div className="input-row">
                                                <input type="text" name='city' id='city' value={regData.city || ''} onChange={e => setRegData({ ...regData, city: e.target.value })} required />
                                                <label htmlFor="city">City <span style={{ color: 'red' }}>*</span></label>
                                                <TfiLocationPin />
                                            </div>
                                            <div className="input-row">
                                                <input type="text" name='state' id='state' value={regData.state || ''} onChange={e => setRegData({ ...regData, state: e.target.value })} required />
                                                <label htmlFor="state">State <span style={{ color: 'red' }}>*</span></label>
                                                <TfiLocationPin />
                                            </div>
                                        </div>
                                        <div className="form-row split-row">
                                            <div className="input-row select-input">
                                                {/* <input type="text" name='country' id='country' value={regData.country || ''} onChange={e => setRegData({...regData, country: e.target.value})} required /> */}
                                                <select name="country" id="country" value={regData.country || ''} onChange={e => setRegData({ ...regData, country: e.target.value })} required>
                                                    <option value="">select country</option>
                                                    {
                                                        countries.map((country, index) => (
                                                            <option key={index} value={country.name}>{country.name}</option>
                                                        ))
                                                    }
                                                </select>
                                                <label htmlFor="country">Country <span style={{ color: 'red' }}>*</span></label>
                                                <TfiLocationPin />
                                            </div>
                                            <div className="input-row date-input">
                                                <input type="date" name='dob' id='dob' value={regData.dob || ''} onChange={e => setRegData({ ...regData, dob: e.target.value })} required />
                                                <label htmlFor="dob">Date of Birth (DOB) <span style={{ color: 'red' }}>*</span></label>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            {/* national data */}
                            {
                                activeStage === 2 && (
                                    <div className="form-pt-two personal-data">
                                        <h1>Identification</h1>
                                        <div className="form-row split-row">
                                            <div className="input-row">
                                                <div className="passport-placeholder" data-title="Passport Photograph">
                                                    {
                                                        regData.profile_photo && (
                                                            <img src={URL.createObjectURL(regData.profile_photo)} alt="" />
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <div className="input-row">
                                                <input
                                                    type="file"
                                                    name="profile_photo"
                                                    id="profile_photo"
                                                    onChange={e => setRegData({ ...regData, profile_photo: e.target.files[0] })}
                                                    hidden="hidden"
                                                />
                                                {
                                                    regData.profile_photo ? (
                                                        <Fragment>
                                                            <span>{regData.profile_photo.name}</span>
                                                            <button type='button' onClick={() => document.getElementById('profile_photo').click()}>Change Photo</button>
                                                        </Fragment>
                                                    ) : (
                                                        <button type='button' onClick={() => loadImage('profile_photo')}> + Upload Passport</button>
                                                    )
                                                }
                                            </div>
                                        </div>
                                        <div className="form-row split-row">
                                            <div className="input-row">
                                                <input type="text" name='state_of_origin' id='state_of_origin' value={regData.state_of_origin || ''} onChange={e => setRegData({ ...regData, state_of_origin: e.target.value })} required />
                                                <label htmlFor="state_of_origin">State of Origin <span style={{ color: 'red' }}>*</span></label>
                                                <TfiLocationPin />
                                            </div>
                                            <div className="input-row select-input">
                                                {/* <input type="text" name='nationality' id='nationality' value={regData.nationality || ''} onChange={e => setRegData({...regData, nationality: e.target.value})} required /> */}
                                                <select name="nationality" id="nationality" value={regData.nationality || ''} onChange={e => setRegData({ ...regData, nationality: e.target.value })} required>
                                                    <option value="">select country</option>
                                                    {
                                                        countries.map((country, index) => (
                                                            <option key={index} value={country.name}>{country.name}</option>
                                                        ))
                                                    }
                                                </select>
                                                <label htmlFor="nationality">Nationality <span style={{ color: 'red' }}>*</span></label>
                                                <TfiLocationPin />
                                            </div>
                                        </div>
                                        <div className="form-row input-row not-required">
                                            <input type="text" name='tax_id' id='tax_id' value={regData.tax_id || ''} onChange={e => setRegData({ ...regData, tax_id: e.target.value })} />
                                            <label htmlFor="tax_id">TAX No.</label>
                                            <HiOutlineReceiptTax />
                                        </div>
                                        <div className="form-row split-row">
                                            <div className="input-row select-input">
                                                <select name="id_type" id="id_type" value={regData.id_type || ''} onChange={e => setRegData({ ...regData, id_type: e.target.value })} required>
                                                    <option value="">select ID type</option>
                                                    <option value="international passport">International Passport</option>
                                                    <option value="driver's license">Driver's License</option>
                                                    <option value="government issued ids">Other Government Issued IDs</option>
                                                </select>
                                                <label htmlFor="id_type">ID Type <span style={{ color: 'red' }}>*</span></label>
                                                <BiIdCard />
                                            </div>
                                            <div className="input-row date-input">
                                                <input type="date" name='id_exp' id='id_exp' value={regData.id_exp || ''} onChange={e => setRegData({ ...regData, id_exp: e.target.value })} required />
                                                <label htmlFor="id_exp">ID Expiration Date <span style={{ color: 'red' }}>*</span></label>
                                            </div>
                                        </div>
                                        {
                                            regData.id_type && (
                                                <Fragment>
                                                    {
                                                        regData.id_type === 'international passport' ? (
                                                            <div className="form-row image-row">
                                                                <span style={{ color: 'red' }}>*</span>
                                                                <input
                                                                    type="file"
                                                                    name='id_front'
                                                                    id='id_front'
                                                                    onChange={e => setRegData({ ...regData, id_front: e.target.files[0] })}
                                                                    hidden='hidden'
                                                                />
                                                                <div className='img-placeholder' onClick={() => loadImage('id_front')} data-name='Data page'>
                                                                    {
                                                                        regData.id_front && (
                                                                            <img src={URL.createObjectURL(regData.id_front)} />
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <Fragment>
                                                                <div className="form-row image-row">
                                                                    <span style={{ color: 'red' }}>*</span>
                                                                    <input
                                                                        type="file"
                                                                        name='id_front'
                                                                        id='id_front'
                                                                        onChange={e => setRegData({ ...regData, id_front: e.target.files[0] })}
                                                                        hidden='hidden'
                                                                    />
                                                                    <div className='img-placeholder' onClick={() => loadImage('id_front')} data-name='ID front'>
                                                                        {
                                                                            regData.id_front && (
                                                                                <img src={URL.createObjectURL(regData.id_front)} />
                                                                            )
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="form-row image-row">
                                                                    <span style={{ color: 'red' }}>*</span>
                                                                    <input
                                                                        type="file"
                                                                        name='id_back'
                                                                        id='id_back'
                                                                        onChange={e => setRegData({ ...regData, id_back: e.target.files[0] })}
                                                                        hidden='hidden'
                                                                    />
                                                                    <div className='img-placeholder' onClick={() => loadImage('id_back')} data-name='ID back'>
                                                                        {
                                                                            regData.id_back && (
                                                                                <img src={URL.createObjectURL(regData.id_back)} />
                                                                            )
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </Fragment>
                                                        )
                                                    }
                                                </Fragment>
                                            )
                                        }
                                        <div className="form-row input-row">
                                            <input type="text" name='id_number' id='id_number' value={regData.id_number || ''} onChange={e => setRegData({ ...regData, id_number: e.target.value })} required />
                                            <label htmlFor="id_number">ID No. <span style={{ color: 'red' }}>*</span></label>
                                            <HiOutlineReceiptTax />
                                        </div>
                                    </div>
                                )
                            }
                            {/* employment data */}
                            {
                                activeStage === 3 && (
                                    <div className="form-pt-three personal-data">
                                        <h1>Employment</h1>
                                        <div className="form-row split-row">
                                            <div className="input-row select-input">
                                                <select name="employment_status" id="employment_status" value={regData.employment_status || ''} onChange={e => setRegData({ ...regData, employment_status: e.target.value })} required>
                                                    <option value="unemployed">Unemployed</option>
                                                    <option value="self employed">Self-Employed</option>
                                                    <option value="employed">Employed</option>
                                                    <option value="contractor">Contractor</option>
                                                </select>
                                                <label htmlFor="employment_status">Employment Status <span style={{ color: 'red' }}>*</span></label>
                                                <MdOutlineBusinessCenter />
                                            </div>
                                            <div className="input-row date-input"></div>
                                        </div>
                                        {
                                            regData.employment_status && regData.employment_status !== 'unemployed' && (
                                                <Fragment>
                                                    <div className="form-row input-row">
                                                        <input type="text" name='employer' id='employer' value={regData.employer || ''} onChange={e => setRegData({ ...regData, employer: e.target.value })} required />
                                                        <label htmlFor="employer">{regData.employment_status === 'employed' ? 'Employer' : 'Registered Name'} <span style={{ color: 'red' }}>*</span></label>
                                                        <GrOrganization />
                                                    </div>
                                                    <div className="form-row input-row">
                                                        <input type="text" name='employment_position' id='employment_position' value={regData.employment_position || ''} onChange={e => setRegData({ ...regData, employment_position: e.target.value })} required />
                                                        <label htmlFor="employment_position">Role (Position occupied in office) <span style={{ color: 'red' }}>*</span></label>
                                                        <GiOrganigram />
                                                    </div>
                                                    <div className="form-row input-row">
                                                        <input type="text" name='employer_address' id='employer_address' value={regData.employer_address || ''} onChange={e => setRegData({ ...regData, employer_address: e.target.value })} required />
                                                        <label htmlFor="employer_address">Office Address <span style={{ color: 'red' }}>*</span></label>
                                                        <TfiLocationPin />
                                                    </div>
                                                </Fragment>
                                            )
                                        }
                                    </div>
                                )
                            }
                            {/* next of kin/beneficiary */}
                            {
                                activeStage === 4 && (
                                    <div className="form-pt-four personal-data">
                                        <h1>Next of Kin's Data</h1>
                                        <div className="form-row input-row">
                                            <input type="text" name='next_of_kin' id='next_of_kin' value={regData.next_of_kin || ''} onChange={e => setRegData({ ...regData, next_of_kin: e.target.value })} required />
                                            <label htmlFor="next_of_kin">Full Name <span style={{ color: 'red' }}>*</span></label>
                                            <MdOutlineDriveFileRenameOutline />
                                        </div>
                                        <div className="form-row input-row">
                                            <input type="text" name='next_of_kin_address' id='next_of_kin_address' value={regData.next_of_kin_address || ''} onChange={e => setRegData({ ...regData, next_of_kin_address: e.target.value })} required />
                                            <label htmlFor="next_of_kin_address">Current Address <span style={{ color: 'red' }}>*</span></label>
                                            <TfiLocationPin />
                                        </div>
                                        <div className="form-row input-row">
                                            <input type="text" name='next_of_kin_phone' id='next_of_kin_phone' value={regData.next_of_kin_phone || ''} onChange={e => setRegData({ ...regData, next_of_kin_phone: e.target.value })} required />
                                            <label htmlFor="next_of_kin_phone">Phone <span style={{ color: 'red' }}>*</span></label>
                                            <AiOutlinePhone />
                                        </div>
                                        <div className="form-row input-row">
                                            <input type="text" name='next_of_kin_email' id='next_of_kin_email' value={regData.next_of_kin_email || ''} onChange={e => setRegData({ ...regData, next_of_kin_email: e.target.value })} required />
                                            <label htmlFor="next_of_kin_email">Email <span style={{ color: 'red' }}>*</span></label>
                                            <CiMail />
                                        </div>
                                        <div className="form-row split-row">
                                            <div className="input-row select-input">
                                                <select name="next_of_kin_relation" id="next_of_kin_relation" value={regData.next_of_kin_relation || ''} onChange={e => setRegData({ ...regData, next_of_kin_relation: e.target.value })} required>
                                                    <option value="">relationship</option>
                                                    <option value="father">Father</option>
                                                    <option value="mother">Mother</option>
                                                    <option value="brother">Brother</option>
                                                    <option value="sister">Sister</option>
                                                    <option value="cousin">Cousin</option>
                                                    <option value="other-family-member">Other Family Member</option>
                                                    <option value="husband">Husband</option>
                                                    <option value="wife">Wife</option>
                                                    <option value="partner">Partner</option>
                                                </select>
                                                <label htmlFor="next_of_kin_relation">ID Type <span style={{ color: 'red' }}>*</span></label>
                                                <GiFamilyTree />
                                            </div>
                                            <div className="input-row date-input"></div>
                                        </div>
                                    </div>
                                )
                            }
                            {/* summary and confirmation */}
                            {
                                activeStage === 5 && (
                                    <div className="form-pt-five personal-data">
                                        <div className="form-row input-row">
                                            <ul>
                                                {
                                                    Object.keys(regData)?.map((title, index) => (
                                                        <Fragment>
                                                            {
                                                                ['profile_photo', 'id_front', 'id_back'].includes(title) ? (
                                                                    regData[title] !== null && (
                                                                        <li key={index}>
                                                                            {capitalizeWords(title.replaceAll('_', ' '))}: <img className={title === 'profile_photo' ? 'square-image' : 'landscape-image'} src={URL.createObjectURL(regData[title])} alt={capitalizeWords(regData[title].name)} />
                                                                        </li>
                                                                    )
                                                                ) : (
                                                                    <li key={index}>{capitalizeWords(title.replaceAll('_', ' '))}: {capitalizeWords(regData[title])}</li>
                                                                )
                                                            }
                                                        </Fragment>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                )
                            }
                            {
                                activeStage === 6 && (
                                    registered ? (
                                        <div className="form-pt-four personal-data">
                                            <div className="response-screen success">
                                                <GrStatusGood />
                                                <p>
                                                    Your request for a {capitalizeWords(regData.account_type.replaceAll('-', ' '))} was submitted successfully.
                                                    You will be contacted via the communication medium you have provided during this registration.
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="form-pt-four personal-data">
                                            <div className="response-screen error">
                                                <GiCancel />
                                                <p>
                                                    Your request failed.
                                                    Please try again later.
                                                </p>
                                            </div>
                                        </div>
                                    )
                                )
                            }
                            {/* BUTTONS */}
                            <div className="btn-row split-row">
                                <div className="left-column">
                                    {
                                        activeStage > 1 && activeStage < form_row_count && (
                                            <button type='button' onClick={() => setActiveStage(activeStage - 1)}>Back</button>
                                        )
                                    }
                                </div>
                                <div className="right-column">
                                    {
                                        activeStage < form_row_count && (
                                            <button type='button' onClick={next}>{activeStage === form_row_count - 1 ? 'Preview form' : 'Next'}</button>
                                        )
                                    }
                                </div>
                            </div>
                            {
                                activeStage === form_row_count && (
                                    <div className="btn-row split-row">
                                        <button type='submit'>Submit Form</button>
                                        <strong onClick={() => setActiveStage(1)}>cancel</strong>
                                    </div>
                                )
                            }
                        </form>
                        <div className="info-box">
                            {
                                tool.toLowerCase() === 'credit-card' ? (
                                    <img src={card} alt="" />
                                ) : (
                                    <img src={man} alt="" />
                                )
                            }
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </Fragment>
    )
}

export default Register
